<template lang="pug">
._layout
  OfflineCompanion
  TheHeaderQuestions
  ._layout-content
    GlobalWrapper
      nuxt
</template>

<script>
import TheHeaderQuestions from '~/components/TheHeaderQuestions'
import OfflineCompanion from '~/components/OfflineCompanion'
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  name: 'Questions',
  middleware: ['Authenticated'],
  components: {
    TheHeaderQuestions,
    OfflineCompanion,
    GlobalWrapper,
  },
}
</script>

<style lang="sass">
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --primaryColorLight: #EFBDBD
  --textColor: #767676
  --textHighlightColor: #232323
  --darkBlueColor: #1A4982
  background-color: var(--bgColor)
  color: var(--textColor)
  font:
    family: 'Montserrat', sans-serif
    size: 16px
</style>
<style scoped lang="sass">
._layout
  &-content
    padding-bottom: 60px
</style>
